<template>
    <div class="item">
        <div class="top">
            <div class="goback" @click="routeback()">
                <font-awesome-icon :icon="['fas', 'angle-left']" />
            </div>
            <!-- <div class="write">               
                <font-awesome-icon :icon="['fas', 'pencil-alt']" />
            </div> -->
        </div>
        <div class="router_view" v-on:scroll.passive="handleScroll">
            <router-view  />
            <div class="scrollToTop" @click="scrollToTop()">
                <font-awesome-icon :icon="['fas', 'arrow-up']" />
            </div>  
            <div class="previousPage" @click="routeback()">
                <font-awesome-icon :icon="['fas', 'angle-left']" />
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    name:'',
    props:[
        
    ],
    data(){
        return{

        }
    },
    mixins:[

    ],
    components:{

    },
    mounted() {
    },
    methods:{
        routeback()
        {
            this.$router.go(-1);
        },
         handleScroll(event) {            
            console.log('총높이',event.target.scrollHeight);
            // console.log(window.screen.height);
            // console.log('현재스크롤',event.target.scrollTop);            
            let currentHeight = window.screen.height;
            let curretnScrollTop = event.target.scrollTop
            if(currentHeight - curretnScrollTop < 0)
            {
                document.querySelector('.scrollToTop').classList.add('showscrollToTop');
            }else{
                document.querySelector('.scrollToTop').classList.remove('showscrollToTop');   
            }
        },
        scrollToTop()
        {
            document.querySelector('.router_view').scrollTo(0,0)
        },
    }
}
</script>
<style lang="scss" scoped>
.item{
    height:calc(100vh - 100px);overflow-y:hidden;
    .top{        
        background: #fff;
        height:50px;
        width: 100%;
        margin-top:1px;         
        box-shadow: 0 2px 5px -5px rgba(0,0,0,0.2);   
        display: flex;
        justify-content: space-between;
        align-items: center;   
        font-size:20px;
        .goback{
            color:rgb(88, 140, 235);
            padding-left: 10px;
        }
        .write{
            padding-right:10px;
            color:rgb(88, 140, 235);
        }
    }
  
    .router_view{
        margin-top:1px;
        height:calc(100vh - 50px);        
        overflow-y:scroll;        
    }
}
</style>